import { ShieldCheck } from "lucide-react";

export const KidFriendlyBadge = ({ onClick, testid = "kid-friendly-badge" }) => {
  const Tag = onClick ? "button" : "span";
  return (
    <Tag data-testid={testid} onClick={onClick} className={`what-kid-badge ${onClick ? "is-clickable" : ""}`}>
      <ShieldCheck size={14} />
      <span><strong>Child friendly</strong> · Kids Mode checks every answer for children under 9</span>
    </Tag>
  );
};
